import React from 'react';
import main_ban_img from '../../assets/images/main-banner-img.png';
import { Link  } from 'react-router-dom';
import { AUTH } from '../../Router/paths';

function Banner(){
    return(
        <div className="main-banner pc-p-4">
        <div className="container-fluid px-5">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="main-banner-content">
                        <h1 className="color-secondary">
                            Hire the best <span className="color-primary">Freelancers</span> for
                            any job, online.
                        </h1>
                        <p className="color-primary">
                            Let go of the past regulations. You're empowered to engage with
                            the utmost qualified people.
                        </p>
                        <h5 className="color-secondary">Without delay. Right on the spot.</h5>
                        <Link to={AUTH.signup} className="primary-btn primary-bg mt-4">Get Started</Link>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="main-banner-img">
                        <img src={main_ban_img} alt="Main Banner" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}
export default Banner;